export { default } from './infinite-scroll-product-list-ds'
export type { InfiniteScrollProductListProps } from './infinite-scroll-product-list-ds.types'
